import React from 'react';
import times from 'lodash/times';
import { TableCell, TableRow } from '../../../CommonComponents/OPL/Table/Table';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { IncomeTableSkeleton } from './components/IncomeTableSkeleton/IncomeTableSkeleton';

interface Props {
  title: string;
}

export const IncomeDetailsLoading = ({ title }: Props) => {
  return (
    <IncomeTableSkeleton title={title}>
      {times(7).map(i => (
        <TableRow key={i}>
          <TableCell width="40%">
            <Shimmer width="100%" height={20} />
          </TableCell>

          {times(6).map(j => (
            <TableCell key={j} width="10%">
              <Shimmer width="100%" height={20} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </IncomeTableSkeleton>
  );
};
